
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function WritersCramp(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Writer’s cramp "}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Writer's cramp is <b>a specific type of focal dystonia</b> that affects your
                                    fingers, hand, or forearm. Focal dystonia of the hands is a neurologic
                                    movement disorder. The brain sends incorrect information to the
                                    muscles, causing involuntary, excessive muscle contractions.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Writeris-cramp/1.png")} alt="Writeris-cramp" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>There are two basic types of writer’s cramp: simple and dystonic.</b></p>
                                <p>Simple writer’s cramp involves difficulty with only writing. The abnormal postures and involuntary
                                    movements begin soon after you pick up a pen. It only affects your ability to write.</p>
                                <p>Dystonic writer’s cramp moves beyond the one task. Symptoms will show up not only during writing,
                                    but also when doing other activities with your hands — like shaving or applying makeup.</p>
                                <p><b>Symptoms</b></p>
                                <p>fingers gripping the pen or pencil very hard</p>
                                <p>wrists flexing</p>
                                <p>fingers extending during writing, making it difficult to hold the pen</p>
                                <p>wrists and elbows moving into unusual positions</p>
                                <p>hands or fingers failing to respond to commands</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Writer%27s_cramp">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default WritersCramp;